import { lightTheme } from "@/customTheme"
import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill={props.disabled ? lightTheme.colors.icon.disable : lightTheme.colors.blackGray}
      fillRule="evenodd"
      d="M5 15a1 1 0 0 1 1 1v2h12v-2a1 1 0 1 1 2 0v2.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 18.5V16a1 1 0 0 1 1-1Z"
      clipRule="evenodd"
    />
    <path
      fill={props.disabled ? lightTheme.colors.icon.disable : lightTheme.colors.blackGray}
      fillRule="evenodd"
      d="M12 4c.552 0 1 .379 1 .846v9.308c0 .467-.448.846-1 .846s-1-.379-1-.846V4.846C11 4.38 11.448 4 12 4Z"
      clipRule="evenodd"
    />
    <path
      fill={props.disabled ? lightTheme.colors.icon.disable : lightTheme.colors.blackGray}
      fillRule="evenodd"
      d="M11.984 13.227 8.63 9.726a.963.963 0 1 0-1.392 1.333l4.08 4.257a.924.924 0 0 0 .666.289c.25 0 .49-.104.668-.289l4.078-4.257a.963.963 0 1 0-1.39-1.333l-3.356 3.501Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgComponent
